import { ElementType, SetStateAction } from 'react';
import { Avatar, IconButton } from '@mui/material';

interface UserAvatarProps {
	handleUserMenuOpen: (event: SetStateAction<any>) => void
}

const UserAvatar:ElementType<UserAvatarProps> = ({handleUserMenuOpen}) => {
	return (
		<IconButton
			onClick={handleUserMenuOpen}
			size="small"
			sx={{ ml: 2 }}
			aria-controls="user-menu"
			aria-haspopup="true"
		>
			<Avatar sx={{ width: 32, height: 32 }}>U</Avatar>
		</IconButton>
	);
}

export default UserAvatar;
